export default __webpack_public_path__ + "static/media/599.91ef1597.png";